import { Link } from "@tanstack/react-router";

import CloudinaryImage from "@/components/cloudinary-image";
import CommunityScoreWheel from "@/components/community-score-wheel";
import { gameUrl } from "@/helpers/games";

import type { GameType } from "../../types";

interface CardProps {
  game: GameType;
}

export default function Card({ game }: CardProps) {
  return (
    <div className="relative flex items-center">
      <CloudinaryImage
        className="inset-shadow-0-0-8 inset-shadow-black mr-2.5 size-10 rounded-[5px] bg-white"
        game={game}
        rW={80}
      />
      <div className="pr-2.5">
        <h2 className="font-semibold text-13/[1.23em] text-white">
          <Link className="link-overlay" to={gameUrl(game)}>
            {game.name}
          </Link>
        </h2>
        <h3 className="mt-0.5 font-normal text-12/[1.5em] text-white/80">
          {game.location.company.name}
        </h3>
      </div>
      {!!game.communityRatingCount &&
        !!game.communityScoreBucket &&
        !!game.communityScorePercentages && (
          <CommunityScoreWheel
            className="ml-auto size-[21px]"
            scores={game.communityScorePercentages}
          />
        )}
    </div>
  );
}
